import type { ExecutionSortField, SortDirection } from '../../services/executionService';

export const executionKeys = {
  all: (organizationId?: string) => ['execution', organizationId ?? 'unknown'] as const,
  lists: (organizationId?: string) => ['execution', organizationId ?? 'unknown', 'instances'] as const,
  list: (
    organizationId: string,
    filtersHash: string,
    page: number,
    pageSize: number,
    sort: string,
  ) => ['execution', organizationId, 'instances', filtersHash, page, pageSize, sort] as const,
  detail: (organizationId: string, executionId: string) => ['execution', organizationId, 'instance', executionId] as const,
  tasks: (organizationId: string, executionId: string, filtersHash: string, sort: string, pageSize: number) =>
    ['execution', organizationId, 'tasks', executionId, filtersHash, sort, pageSize] as const,
  analytics: (organizationId: string, templateId?: string | null, range?: number | null) =>
    ['execution', organizationId, 'analytics', templateId ?? null, range ?? null] as const,
  templates: (organizationId?: string) => ['execution', organizationId ?? 'unknown', 'templates'] as const,
};

export const buildSortKey = (field: ExecutionSortField, direction: SortDirection) => `${field}:${direction}`;
